export const PVQD_DATABASE_ID = '67b7575a6c7397bd463488d9';

export const PVQD_70DB_COLLECTION_ID = '6821a3cb6dbf21c7d84eb717';

export const pvqdVoiceDatabaseCitation = {
  databaseName: 'PVQD',
  databaseFullName: 'Perceptual Voice Qualities Database',
  databaseAuthors: ['Patrick R. Walden'],
  publicationYear: 2022,
  citations: [
    {
      citationText:
        'Walden, P. R. (2022). Perceptual Voice Qualities Database (PVQD) (Version 4) [Data set]. Mendeley Data.',
      citationLink: 'https://doi.org/10.17632/9dz247gnyb.2',
    },
  ],
  licenses: [
    {
      licenseText: 'CC BY 4.0 License',
      licenseLink: 'https://creativecommons.org/licenses/by/4.0/',
      licenseConditions: null,
    },
  ],
};

export const pvqdSustainedVowelsAnchorsCollection = {
  collectionName: 'PVQD sustained vowels anchors',
  collectionDescription:
    'Sustained vowel samples grouped by mean frequency for consensus-anchor exploration.',
  voiceDatabaseId: pvqdVoiceDatabaseCitation,
  modificationsApplied: [
    '1500_sustained_a_extractions',
    'normalization_to_70dB',
  ],
  citations: [],
};

export const pvqdSustainedVowelsTrainingCollection = {
  collectionName: 'PVQD sustained vowels training subset',
  collectionDescription:
    'Sustained vowel samples used for the three-phase perceptual training workflow.',
  voiceDatabaseId: pvqdVoiceDatabaseCitation,
  modificationsApplied: [
    'standardization_of_demographic_data',
    'normalization_to_70dB',
  ],
  citations: [],
};
